import * as React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
} from "@material-ui/core";
import { SyncEventConfigComponent } from "./SyncEvents";
import ActionConfig from "./ActionConfig";
import { Maps } from "lib";
import { ApiSyncActionConfig, ApiOrderStateLabel } from "lib/api";

function validateConfig(config: any) {
  return (
    Boolean(config.type) &&
    Boolean(config.action) &&
    Boolean(config.action.type) &&
    config.to !== undefined &&
    config.to !== null
  );
}

const EventOrderStatutConfig: SyncEventConfigComponent<any> = ({
  config,
  onChange,
}) => {
  const to = config.to === undefined ? "" : config.to;
  const from =
    config.from === undefined || config.from === null ? "" : config.from;
  const action: ApiSyncActionConfig =
    config.action === undefined ? { type: "" } : config.action;

  if (!onChange) {
    return (
      <>
        <span>
          Lorsque le statut devient{" "}
          <strong>{Maps.valueByKey(ApiOrderStateLabel, to, "???")}</strong>
        </span>
        {from !== "" && (
          <span>
            {" "}
            et uniquement si le statut était{" "}
            <strong>{Maps.valueByKey(ApiOrderStateLabel, from, "???")}</strong>
          </span>
        )}
        <ActionConfig config={action} />
      </>
    );
  }

  function handleSelectChange(
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) {
    const prop = event.target.name!;
    let value: number | undefined = event.target.value as number;
    if (value === -1) {
      value = undefined;
    }
    const newconfig = { ...config, [prop]: value };
    if (onChange) {
      onChange(newconfig, validateConfig(newconfig));
    }
  }

  function handleActionChange(action: ApiSyncActionConfig, valid: boolean) {
    const newconfig = { ...config, action };
    if (onChange) {
      onChange(newconfig, valid && validateConfig(newconfig));
    }
  }

  return (
    <>
      <FormControl fullWidth required>
        <InputLabel>Lorsque le statut devient</InputLabel>
        <Select name="to" value={to} onChange={handleSelectChange}>
          {Array.from(ApiOrderStateLabel).map(([k, v]) => (
            <MenuItem key={k} value={k}>
              {v}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <InputLabel>Uniquement si le statut était</InputLabel>
        <Select name="from" value={from} onChange={handleSelectChange}>
          <MenuItem value={-1}>
            <em>Sans importance</em>
          </MenuItem>
          {Array.from(ApiOrderStateLabel).map(([k, v]) => (
            <MenuItem key={k} value={k}>
              {v}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Divider />
      <ActionConfig config={action} onChange={handleActionChange} />
    </>
  );
};

export default EventOrderStatutConfig;
